import type { CandidateConfig } from '../../types/config.ts';
import { patternTile } from '../../lib/colors.ts';

const TILE = 12;

/** Candidate identity: color swatch + shape/pattern + text label. Three
 *  redundant cues so nothing depends on hue alone (CVD-safe). */
export function CandidateToken({
  candidate,
  color,
  withName = true,
  size = 14,
}: {
  candidate: CandidateConfig;
  color: string;
  withName?: boolean;
  size?: number;
}) {
  const svg =
    `<svg width="${size}" height="${size}" viewBox="0 0 ${TILE} ${TILE}" ` +
    `xmlns="http://www.w3.org/2000/svg" aria-hidden="true">` +
    `${patternTile(candidate.pattern, color, TILE)}</svg>`;
  return (
    <span className="cand-token">
      <span
        className="cand-token__swatch"
        style={{ borderColor: color }}
        // Generated from config (fixed pattern set + config color); no user input.
        dangerouslySetInnerHTML={{ __html: svg }}
      />
      {withName ? (
        <span className="cand-token__name">{candidate.shortName ?? candidate.name}</span>
      ) : null}
      {candidate.withdrawn ? <span className="badge badge--muted">withdrew</span> : null}
    </span>
  );
}
